import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { AlertAction } from '../alerts.service';

@Component({
    selector: 'app-action-snackbar',
    templateUrl: './action-snackbar.component.html',
    styleUrls: ['./action-snackbar.component.scss']
})
export class ActionSnackbarComponent {

    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: { message: string; action: AlertAction },
                private readonly ref: MatSnackBarRef<ActionSnackbarComponent>) {}

    public close() {
        this.data.action.action();
        this.ref.dismissWithAction();
    }

}
